import { render, staticRenderFns } from "./LegalWiseJuneAUS.vue?vue&type=template&id=7f35d812&scoped=true"
import script from "./LegalWiseJuneAUS.vue?vue&type=script&lang=js"
export * from "./LegalWiseJuneAUS.vue?vue&type=script&lang=js"
import style0 from "./LegalWiseJuneAUS.vue?vue&type=style&index=0&id=7f35d812&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f35d812",
  null
  
)

export default component.exports